import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Stack,
  Box,
} from '@mui/material';
import { Link } from 'react-router-dom';

interface RdsConnectionDialogProps {
  open: boolean;
  onClose: () => void;
  teleportUrl: string | undefined;
}

export const RdsConnectionDialog: React.FC<RdsConnectionDialogProps> = ({
  open,
  onClose,
  teleportUrl,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Database Teleport Access</DialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>
          You can access Database via <strong>Teleport</strong>.
        </Typography>

        <Stack spacing={3} mt={2}>
          <Box>
            <Typography variant="h6">🔐 Connect to Teleport</Typography>
            <Typography variant="body2" color="textSecondary">
              Teleport provides secure browser-based and CLI access to
              databases.
            </Typography>
            {teleportUrl ? (
              <Button
                component={Link}
                to={teleportUrl}
                variant="contained"
                color="primary"
                sx={{ mt: 1 }}
              >
                Teleport Documentation
              </Button>
            ) : (
              <Typography
                color="textSecondary"
                sx={{ mt: 1, fontStyle: 'italic' }}
              >
                Teleport documentation not available
              </Typography>
            )}
          </Box>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
